import { Button, Collapse, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { AccountBox, KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { ParticipantStatus, ParticipantType, Registration } from "../../../../Shared/GeneratedTypes";
import { ApplicationData } from "../../../types";
import "../../../client.css";
import { DateTime } from "luxon";
import * as constants from "../../../../Shared/clientConstants";
import { Participant } from "../../../../Shared/sharedTypes";

const mapState = ({
    localizations,
}: ApplicationData) => ({
    localizations: localizations!,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {
    participants: Participant[];
};

function ParticipantSection(
    {
        localizations,
        participants
    }: PropTypes) {

    function getRoleTitle(role: ParticipantType | undefined) {
        let title = "";
        switch (role) {
            case ParticipantType.Client:
                title = localizations.menteeRole;
                break;
            case ParticipantType.Observer:
                title = localizations.internalObserverRole;
                break;
            case ParticipantType.Mentor:
                title = localizations.mentorRole;
                break;
            case ParticipantType.ExternalObserver:
                title = localizations.externalObserverRole;
                break;
        }
        return title;
    }

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={2}>{participants.length} {localizations.activeParticipants}</TableCell>
                    </TableRow>
                </TableHead>
                
                <TableBody>
                    {participants.map((row) => (
                        <TableRow key={row.deviceId}>
                            <TableCell className="participant-data-row" style={{ width: '10%', paddingLeft: '3rem' }}>
                                <img src={row?.photoUrl !== null ? row.photoUrl : constants.DEFAULT_AVATAR}
                                    style={{ height: '100px', width: '100px' }} />
                            </TableCell>
                            <TableCell className="participant-data-row">
                                <p>
                                    {row?.firstName} {row?.lastName} {row?.title ? ` - ${row.title}` : ""}
                                    {getRoleTitle(row?.role)}
                                </p>
                                <p>
                                    <a href={`mailto:${row?.email}`} target="_blank">{row?.email}</a>
                                </p>
                                <p>{row?.phoneNumber}</p>

                                {row?.accessHistory?.admittedUTC && (
                                    <p>
                                        {localizations.admitted} {new Date(row.accessHistory.admittedUTC).toLocaleString()}
                                        {row.accessHistory.admittedBy && (
                                            <span> {localizations.by} {row.accessHistory.admittedBy}</span>
                                        )}
                                    </p>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                
            </Table>
        </TableContainer>
    );
}

export default connector(ParticipantSection);